import {useDisclosure} from '@mantine/hooks';
import type React from 'react';
import {MdPersonAdd} from 'react-icons/md';
import {
  COLOR_PRIMARY_2,
  COLOR_WHITE,
} from '../../../config/constants/colorCodes';
import {useAuth} from '../../../core/usecases/useAuth';
import {useHandleFollowCompany} from '../../../core/usecases/useHandleFollowCompany';
import {NoLoginAlertModal} from '../NoLoginAlertModal';

type Props = {
  companyId: number;
  followerCountInital: number;
  isFollowedInital: boolean;
};

export const FollowCompanyTypeA: React.FC<Props> = ({
  companyId,
  followerCountInital,
  isFollowedInital,
}) => {
  const {isSignedIn} = useAuth();
  const [opened, {open, close}] = useDisclosure(false);
  const {handleFollowCompany, followCountUpdated, isFollowed} =
    useHandleFollowCompany({
      companyId,
      followCount: followerCountInital,
      followed: isFollowedInital,
    });

  const onClick = async () => {
    if (!isSignedIn) {
      open();
      return;
    }

    return handleFollowCompany();
  };

  return (
    <div className="flex h-[24px] flex-row">
      {isFollowed ? (
        <button
          type="button"
          className="py-2 flex w-[110px] items-center justify-center gap-4 rounded-4 border-2 border-primary-2 bg-primary-2 px-8 text-xs"
          onClick={onClick}
        >
          <MdPersonAdd color={COLOR_WHITE} size="16px" />
          <span className="text-white">フォロー中</span>
        </button>
      ) : (
        <button
          type="button"
          className="py-2 flex w-[110px] items-center justify-center gap-4 rounded-4 border-2 border-primary-2 bg-white px-8 text-xs"
          onClick={onClick}
        >
          <MdPersonAdd color={COLOR_PRIMARY_2} size="16px" />
          <span className="text-primary-2">フォローする</span>
        </button>
      )}
      <span className="translate-x-[15%] items-center justify-center whitespace-nowrap rounded bg-background-3 py-4 text-sm text-primary-2 before:absolute before:top-1/2 before:-translate-x-full before:-translate-y-1/2 before:border-4 before:border-transparent before:border-r-background-3 ">
        <div className="mx-8">{followCountUpdated}</div>
      </span>
      <NoLoginAlertModal opened={opened} onClose={close} />
    </div>
  );
};
